import React from "react";
import { useTranslation } from "react-i18next";

type GatepassProfileSectionProps = {
  testIdBase: string;
  profileImgUrl?: string;
  fullNameEn: string;
  fullNameAr: string;
  dateOfBirth: string;
  passportNumber: string;
  passportExpiryDate: string;
  gatepassNo: string | number;
};

const GatepassProfileSection: React.FC<GatepassProfileSectionProps> = ({
  testIdBase,
  profileImgUrl,
  fullNameEn,
  fullNameAr,
  dateOfBirth,
  passportNumber,
  passportExpiryDate,
  gatepassNo,
}) => {
  const { t } = useTranslation();

  return (
    <div className="w-full rounded-xl bg-white p-6" data-testid={`${testIdBase}-profile-section`}>
      <div className="flex w-full items-center gap-6">
        {/* Profile image */}
        <div className="w-[188px] aspect-[188/140] shrink-0 rounded-xl overflow-hidden bg-gray-100">
          {profileImgUrl ? (
            <img
              src={profileImgUrl}
              alt={t("gatepass.photograph")}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-xs text-gray-500">
              {t("gatepass.photograph")}
            </div>
          )}
        </div>

        {/* Details */}
        <div className="grid min-w-0 flex-1 grid-cols-1 items-start gap-y-2 md:grid-cols-2 md:gap-x-[100px]">
          {[
            [t("gatepass.fullName-en"), fullNameEn],
            [t("gatepass.passport-no-or-emirates-id"), passportNumber],
            [t("gatepass.fullName-ar"), fullNameAr],
            [t("gatepass.passport-expiry-date"), passportExpiryDate],
            [t("gatepass.date-of-birth"), dateOfBirth],
            [t("gatepass.tableHeaders.gatePassNo"), String(gatepassNo)],
          ].map(([label, value]) => (
            <div className="grid min-w-0 grid-cols-[180px_minmax(0,1fr)]" key={label}>
              <p className="text-sm font-normal w-[180px] shrink-0 text-gray-600">{label}</p>
              <p className="min-w-0 text-sm font-bold break-words break-all text-gray-900">
                {value}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GatepassProfileSection;
